import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Tool } from '../interfaces/user/Tool';
import * as moment from 'moment';
import { ToolBook } from '../interfaces/user/ToolBook';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  numero = 0;
  products: ToolBook [] = [];
  productsLocalStorage: ToolBook [] = [];

  private elementsSubject: BehaviorSubject<ToolBook[]> = new BehaviorSubject<ToolBook[]>([]);
  elementsSubject$ = this.elementsSubject.asObservable();

  constructor() { }

  addToCart(toolBook: ToolBook){
    if (localStorage.getItem('products')){
      this.productsLocalStorage = JSON.parse(localStorage.getItem('products'));
    }
    if (this.productsLocalStorage.filter(e => e.idTool === toolBook.idTool).length > 0) {
      //TODO LANZAR MODAL PARA AVISAR DE QUE NO SE PUEDE AÑADIR UN NUEVO PRODUCTO YA EXISTENTE
    } else {
      // if (localStorage.getItem('products')){
      //   this.productsLocalStorage = JSON.parse(localStorage.getItem('products'));
      // }
      this.productsLocalStorage.push(toolBook);
      localStorage.setItem('products', JSON.stringify(this.productsLocalStorage));
    }
    this.elementsSubject.next(this.productsLocalStorage);
 }

  removeFromCart(product: ToolBook){
    const storageProducts = JSON.parse(localStorage.getItem('products'));
    this.productsLocalStorage =  storageProducts.filter(e => e.idTool !== product.idTool);
    localStorage.setItem('products', JSON.stringify(this.productsLocalStorage));

    // this.products =  this.products.filter(e => e.idTool !== product.idTool);
    this.elementsSubject.next(this.productsLocalStorage);
  }

  cleanCart(){
    this.products = [];
    localStorage.clear();
    this.productsLocalStorage = [];
    this.elementsSubject.next(this.productsLocalStorage);
  }

  getCartProduct(){
    return this.elementsSubject.asObservable();
  }

  getTotalPrice(begin: Date, end: Date, tool: Tool): number {
    const startDate = moment(begin);
    const endDate = moment(end);
    const daysSelected = endDate.diff(startDate, 'days') + 1;
    let totalPrice: number;
    if (daysSelected === 1) {
      //only one day
      totalPrice = tool.priceFirstDay;
    }
    if (daysSelected > 1 && daysSelected <= 5){
      // between 2 and 5 days
      totalPrice = (tool.priceFirstDay + ((daysSelected - 1) * tool.priceSecondToFifthDay));
    }
    if (daysSelected > 5){
      // more 5 days
      totalPrice = (tool.priceFirstDay +
        (4 * tool.priceSecondToFifthDay) +
        ((daysSelected - 5) * tool.priceSixthDayAndLater));
    }
    return totalPrice;
  }
}
